import ContactFormSection from '@/components/site/ContactFormSection';
import SiteLayout from '@/components/site/SiteLayout';

const ContactPage = () => {
  return (
    <SiteLayout
      title='Contact DocMoonlight | Request Physician Coverage'
      description='Contact DocMoonlight to request onsite, virtual, or hybrid physician coverage for imaging centers, infusion centers, teleradiology, or resident opportunities.'
      keywords={[
        'request physician coverage',
        'contact DocMoonlight',
        'imaging center coverage',
        'infusion coverage',
      ]}
    >
      <ContactFormSection />
    </SiteLayout>
  );
};

export default ContactPage;
